import React from "react";
import { SITE } from "../data/site";
import { Logo } from "./Logo";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#0E0E0D] text-[#FAF9F6] pt-20 pb-10"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-8 lg:gap-12 pb-16 border-b border-[#FAF9F6]/15">
                    <div className="col-span-12 lg:col-span-5">
                        <Logo variant="dark" size={140} />
                        <p className="mt-6 text-[#FAF9F6]/70 max-w-sm leading-relaxed font-light">
                            {SITE.description}
                        </p>
                    </div>

                    <div className="col-span-6 lg:col-span-2">
                        <div className="overline text-[#C7B299] mb-5">Navigate</div>
                        <ul className="space-y-3 font-light">
                            <li><a href="#home" className="dd-link">Home</a></li>
                            <li><a href="#services" className="dd-link">Services</a></li>
                            <li><a href="#portfolio" className="dd-link">Work</a></li>
                            <li><a href="#about" className="dd-link">Studio</a></li>
                            <li><a href="#contact" className="dd-link">Contact</a></li>
                        </ul>
                    </div>

                    <div className="col-span-6 lg:col-span-2">
                        <div className="overline text-[#C7B299] mb-5">Connect</div>
                        <ul className="space-y-3 font-light">
                            {SITE.socials.map((s) => (
                                <li key={s.name}>
                                    <a
                                        href={s.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="dd-link"
                                        data-testid={`footer-social-${s.name.toLowerCase()}`}
                                    >
                                        {s.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="col-span-12 lg:col-span-3">
                        <div className="overline text-[#C7B299] mb-5">Studios</div>
                        <p className="text-[#FAF9F6]/75 leading-relaxed text-sm font-light mb-4">
                            {SITE.offices[0].address}
                        </p>
                        <p className="text-[#FAF9F6]/75 leading-relaxed text-sm font-light">
                            {SITE.offices[1].address}
                        </p>
                    </div>
                </div>

                <div className="pt-8 flex flex-col md:flex-row md:items-center justify-between gap-4 text-[12px] text-[#FAF9F6]/55 font-light">
                    <div>© {new Date().getFullYear()} {SITE.legal}. All rights reserved.</div>
                    <div className="flex items-center gap-6">
                        <a href={`mailto:${SITE.email}`} className="dd-link">{SITE.email}</a>
                        <a href={`tel:${SITE.phones[0].replace(/\s/g, "")}`} className="dd-link">
                            {SITE.phones[0]}
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};
